/*
  src/redux/version/actions.js

  Created by erikchristensen on 11/03/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import callAPI from '../callAPI';

import {
  VERSION_REQUESTED,
  VERSION_LOADED,
  VERSION_FAILED_TO_LOAD
} from './constants';

import {
  RELEASE_TAG,
  ACTIVE_PROFILE
} from '../../../config';

export function loadVersion(){
  return callAPI({
    public:true,
    path:'/pub/v1/configuration',
    begin:{
      type:VERSION_REQUESTED,
      payload:() => ({
        environment:ACTIVE_PROFILE,
        frontend:RELEASE_TAG        
      })
    },
    success:{
      type:VERSION_LOADED,
      payload:(res) => ({
        environment:ACTIVE_PROFILE,
        frontend:RELEASE_TAG,
        backend:res.version
      })
    },
    failure:{
      type:VERSION_FAILED_TO_LOAD
    }    
  });
}


// WEBPACK FOOTER //
// ./src/shared/redux/version/actions.js